module.exports = __webpack_public_path__ + "img/grid-5.f4a91a2d.svg";